import { cva, type VariantProps } from 'class-variance-authority';
import { focusRing, uiMarker, uiMarkerLayout } from './shared';

/**
 * LOT CARD
 *
 * One vehicle on the auction pages: a 4:3 picture with a badge in each top
 * corner, then a title over a line of detail, a menu on the right, and the
 * price along the bottom. Inventory and Sales each drew this by hand and
 * they had already diverged — one truncated its detail line, the other did
 * not; one had a lot-number badge, the other did not.
 *
 * The whole card is the click target, so it carries the focus ring; the
 * kebab inside it stops propagation itself.
 */
export const lotCardRecipe = cva(
  [
    uiMarker,
    'overflow-hidden rounded-xl border border-border bg-card text-left',
  ],
  {
    variants: {
      interactive: {
        true: [
          'cursor-pointer transition-shadow hover:shadow-e2',
          focusRing,
        ].join(' '),
        false: '',
      },
      /** An archived lot: the card and its picture fade back. */
      muted: {
        true: 'opacity-70',
        false: '',
      },
    },
    defaultVariants: { interactive: true, muted: false },
  }
);

/** Everything under the picture. */
export const lotCardBodyRecipe = cva([
  uiMarker,
  uiMarkerLayout,
  'flex flex-col gap-2 p-4',
]);

/**
 * The top-left overlay — the lot number on the Sales page. MediaFrame's
 * `corner` is the top-right one, where the status badge sits.
 */
export const lotCardCornerStartRecipe = cva([
  uiMarker,
  'absolute left-2 top-2 flex items-center gap-1',
]);

export type LotCardRecipeProps = VariantProps<typeof lotCardRecipe>;
